import { Component, NgZone, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { HomeService } from '@app/shared/services/home.service';
import { ZendeskService } from '@state/zendesk';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'fl-home',
  styleUrls: ['./home.component.scss'],
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit, OnDestroy {
  header = 'The OS for Alternative Assets';
  heroIllustration = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ? '/assets/home/hero-illustration-v2-static.svg'
    : '/assets/home/hero-illustration-v2.svg';
  foldText =
    'Join the hundreds of organizations raising and managing SPVs, venture capital and private equity funds on Flow.';
  referralLocation: string;

  constructor(
    private homeService: HomeService,
    private ngZone: NgZone,
    private route: ActivatedRoute,
    public zendeskService: ZendeskService
  ) {}

  ngOnInit() {
    this.referralLocation = this.route.snapshot.queryParams.referral_location;
    this.referralLocation = this.referralLocation
      ? `?prefill_Referral+Location=${this.referralLocation}&hide_Referral+Location=true`
      : '?hide_Referral+Location=true';

    if (this.referralLocation.includes('?prefill_Referral+Location')) {
      this.homeService.onScrollToRequestDemo();
    }

    this.ngZone.runOutsideAngular(() => {
      this.zendeskService.toggleZendeskWidgetDisplay();
    });
  }

  ngOnDestroy() {
    this.zendeskService.toggleZendeskWidgetDisplay();
  }
}
